import { Text, UnstyledButton } from '@mantine/core';
import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ResultsClause } from '../results-help/results-clause-help-content';

import classes from './results-clause-cards.module.css';

const CLAUSE_OPTIONS: ResultsClause[] = ['gp', 'new'];

export interface ResultsClauseCardsProps {
  value: ResultsClause;
  onChange: (value: ResultsClause) => void;
}

export const ResultsClauseCards: FC<ResultsClauseCardsProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div
      aria-label={t('sampling.results.clause.group_label')}
      className={classes.clauseCards}
      role="radiogroup"
    >
      {CLAUSE_OPTIONS.map((clause) => {
        const active = value === clause;

        return (
          <UnstyledButton
            key={clause}
            aria-checked={active}
            className={clsx(classes.card, active && classes.cardActive)}
            onClick={() => onChange(clause)}
            role="radio"
            type="button"
          >
            <div className={classes.cardBody}>
              <Text className={classes.cardTitle} component="span">
                {t(`clauses.${clause}`)}
              </Text>
              <Text className={classes.cardCase} component="span">
                {t(`sampling.results.clause.${clause}_case`)}
              </Text>
            </div>
          </UnstyledButton>
        );
      })}
    </div>
  );
};

export default ResultsClauseCards;
